import React from "react";
import { Col, Row, Form, Select, InputNumber } from "antd";
import { OPTIONAL_VALUES } from '@frontend/constants/initialValues'
import LabelTooltip from "@frontend/components/shared/label-tooltip/LabelTooltip";
const FilesForm = ({form, initialValues, readonly = false}) => {

    const { getFieldDecorator } = form

    return(
        <>
            <Row>
                <Col sm={{ span: 11 }} xs={{ span: 24,offset: 0}}>
                    <Form.Item
                        label="Archivos de Curriculum"
                    >
                        {getFieldDecorator("hidden_curriculum", {initialValue: initialValues.hidden_curriculum})(
                            <Select
                            style={{ width: "100%" }}
                            optionLabelProp="label"
                            placeholder="Selecciona una opción"
                            disabled={readonly == true}
                            >
                            {OPTIONAL_VALUES.map((item) => (
                                <Select.Option key={item.value} value={item.value} label={`${item.name}` || ""}>{item.name}</Select.Option>
                            ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col sm={{ span: 11 }} xs={{ span: 24,offset: 2}}>
                    <Form.Item
                    >
                        <LabelTooltip
                          tooltip="Si dejas este campo en 0 el postulante podra cargar archivos adicionales de forma opcional"
                          label="Cantidad de archivos adicionales obligatorios"
                          classname="form-label-question"
                        />
                        {getFieldDecorator("number_required_files", {initialValue: initialValues.number_required_files})(
                            <InputNumber style={{borderColor: "#d9d9d9", width: "100%"}} disabled={readonly == true} />
                        )}
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

export default FilesForm
